/** Texts of the settings pages (en), below `projects.settings`. */
export const settings = {
  title: 'Project types and phases',
  description: 'Which kinds of projects the company runs and which phases their services have.',
  current: 'Current',
  archived: 'Archived',
  archiveFilter: 'Archive',
  numberHint: 'What project numbers look like is set in the number sequence.',
  numberLink: 'Go to settings',
  empty: 'No project types yet',
  emptyHint:
    'The standard templates create common project types and phase templates. Everything can be changed afterwards.',
  createDefaults: 'Create standard templates',
  defaultsCreated: 'Standard templates created.',
  noArchived: 'Nothing archived',
  actionsFor: 'Actions for {{name}}',
  archive: 'Archive',
  restore: 'Restore',
  archivedToast: 'Archived.',
  restored: 'Restored.',
  saved: 'Changes saved.',
  types: {
    title: 'Project types',
    description: 'The type decides which sections a project has.',
    new: 'New project type',
    createTitle: 'New project type',
    editTitle: 'Edit project type',
    created: 'Project type created.',
    name: 'Name',
    descriptionField: 'Description',
    sections: 'Sections',
    object: 'Object',
    services: 'Services',
    openEnded: 'ongoing',
    usesObject: 'Object',
    usesObjectHint: 'The project refers to a building or property.',
    usesServices: 'Services and phases',
    usesServicesHint: 'The project has services, e.g. fire safety concept, with phases.',
    openEndedField: 'Ongoing mandate',
    openEndedHint: 'No planned end, only an end of contract, e.g. fire safety officer.',
    defaultTemplate: 'Phase template',
    defaultTemplateHint: 'Proposed for new services in projects of this type.',
    noTemplate: 'None',
    archivedTemplate: 'Archived template',
    sortOrder: 'Order',
    sortOrderHint: 'Smaller numbers come first in pickers.',
    empty: 'No project types yet',
    emptyHint: 'Create the first type with “New project type”.',
    archiveTitle: 'Archive project type?',
    archiveDescription:
      '“{{name}}” is no longer offered for new projects. Existing projects keep their type.',
  },
  templates: {
    title: 'Phase templates',
    description: 'Phases a new service takes over. After that each project keeps its own.',
    new: 'New template',
    createTitle: 'New phase template',
    editTitle: 'Edit phase template',
    created: 'Phase template created.',
    name: 'Name',
    nameHint: 'E.g. “HOAI building design” or “AHO fire safety”.',
    phases: 'Phases',
    phaseCount_one: '{{count}} phase',
    phaseCount_other: '{{count}} phases',
    phasesHint: 'The code is optional, e.g. LPH 1. At most {{max}} phases.',
    codePlaceholder: 'Code',
    phasePlaceholder: 'Name of the phase',
    codeOf: 'Code of phase {{position}}',
    nameOf: 'Name of phase {{position}}',
    moveUp: 'Move phase {{position}} up',
    moveDown: 'Move phase {{position}} down',
    remove: 'Remove phase {{position}}',
    addPhase: 'Add phase',
    empty: 'No phase templates yet',
    emptyHint: 'Services without a template start without phases.',
    archiveTitle: 'Archive phase template?',
    archiveDescription:
      '“{{name}}” is no longer offered for new services. Phases in existing projects stay as they are.',
  },
  errors: {
    name: 'Enter a name.',
    phases: 'Every phase needs a name; 1 to 30 phases are allowed.',
    sortOrder: 'Enter a whole number from 0 to 9999.',
    defaultTemplateId: 'The chosen template is no longer available.',
    invalid: 'Check the entry.',
    invalidInput: 'Check the entries.',
    versionConflict: 'Changed by someone else in the meantime. Close the dialog and open it again.',
    notFound: 'Not found. The entry may have been archived.',
    forbidden: 'A permission is missing for this.',
  },
};
